import { itemSliceActions } from "./itemSlice"

export const itemActions = {
    ...itemSliceActions,
}
